/* eslint-disable no-unused-vars */
import React, { useRef, useState } from 'react';
import { TextInput } from '@manulife/mux';
import { Eye1, Eye2 } from '@manulife/mux-cds-icons';
import { InputLayout } from '../InputLayout';
import { generateCustomStyles, styles } from '../../../../styles/input.styles';

export const PasswordInput = ({
  placeholder,
  value,
  onChange,
  mask,
  disabled,
  name,
  onBlur = () => {},
  ...props
}) => {
  const passwordStrengthRef = useRef(null);
  const customStyles = {
    ...generateCustomStyles(props.error, disabled),
    ...props.customStyles,
  };

  const [visible, setVisible] = useState(false);

  const onBlurPassword = () => {
    passwordStrengthRef.current?.validatePasswordOnBlur();
    onBlur();
  };

  return (
    <InputLayout
      {...props}
      error={props.error}
      showErrorText={props.showErrorText}
    >
      <TextInput
        // {...props}
        variant={TextInput.VARIANT.BASIC_LINE}
        placeholder={placeholder}
        value={value}
        onChange={(val) => onChange(val, name)}
        icon={<EyeToggle visible={visible} setVisible={setVisible} />}
        isIconClickable={true}
        type={!visible ? 'password' : 'text'}
        mask={mask}
        disabled={disabled}
        label={props.label || ''}
        customStyle={customStyles}
      />
      {/* <PasswordMeter
        showPasswordMeter
        ref={passwordStrengthRef}
        password={value}
        policyCheck={policyCheck}
        setPolicyCheck={setPolicyCheck}
      /> */}
    </InputLayout>
  );
};

const EyeToggle = ({ visible, setVisible }) => {
  return visible ? (
    <Eye2 fontSize="1.3rem" onClick={() => setVisible(!visible)} />
  ) : (
    <Eye1 fontSize="1.3rem" onClick={() => setVisible(!visible)} />
  );
};
